"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _classnames = _interopRequireDefault(require("classnames"));
var _info = require("@catalytic/catalytic-icons/lib/glyphs/info.svg");
var _WebformView = require("../../View/WebformView/WebformView");
var _debounce2 = require("../../const/debounce");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Menu = _interopRequireDefault(require("../../Component/Menu/Menu"));
var _getErrorMessage = _interopRequireDefault(require("../../utils/getErrorMessage"));
var _getFieldValue = _interopRequireDefault(require("../../utils/getFieldValue"));
var _nextInputID = _interopRequireDefault(require("../../utils/nextInputID"));
var _excluded = ["children", "classes", "className", "description", "descriptionClassName", "disabled", "displayErrors", "error", "errorMessage", "hasError", "hasValidation", "id", "inputClassName", "inputElementClassName", "label", "labelClassName", "name", "onBlur", "onChange", "placeholder", "placeholderClassName", "readOnly", "required", "showDescriptionInTooltip", "theme", "type"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'Input';
var Style = function Style(theme /*: ThemeType*/) {
  var inputMarginTop = {
    '& + $input': {
      marginTop: theme.functions.toRem(theme.variables.inputMarginTop)
    }
  };
  return {
    root: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
      marginBottom: theme.functions.toRem(theme.variables.inputMarginBottom),
      backgroundColor: theme.colors.white,
      textAlign: 'left'
    }),
    errorMargin: {
      marginBottom: 0
    },
    label: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.baseText), inputMarginTop), {}, {
      display: 'block',
      color: theme.colors.black,
      fontWeight: 700
    }),
    labelWithTooltip: {
      display: 'inline'
    },
    description: _objectSpread(_objectSpread({}, theme.typography.smallText), inputMarginTop),
    placeholder: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.smallText), inputMarginTop), {}, {
      color: theme.colors.slateGrey
    }),
    errorMessage: _objectSpread(_objectSpread({}, theme.mixins.inputErrorMessage), inputMarginTop),
    input: theme.mixins.inputMargin,
    openerContainer: {
      verticalAlign: 'bottom'
    },
    helpOpener: {
      color: theme.colors.battleshipGrey,
      fontSize: '1.375rem',
      marginLeft: '0.25rem'
    },
    tooltipContainer: _objectSpread({
      display: 'block'
    }, inputMarginTop),
    tooltipLabel: theme.typography.header5,
    tooltip: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
      padding: '1rem',
      textAlign: 'left'
    })
  };
};
/*:: export type Props = InjectSheetProvidedProps &
  HTMLInputElement & {
    children?: React.Node,
    description?: React.Node,
    descriptionClassName?: string,
    displayErrors: boolean,
    error?: Error | React.Element<any>,
    errorMessage?: string,
    hasError: boolean,
    // Toggles validation logic tied to `field-restrictions` feature flag
    hasValidation: boolean,
    inputClassName?: string,
    inputElementClassName?: string,
    label?: string,
    labelClassName?: string,
    onBlur?: ({
      currentTarget: { id: string, name: string, value: string }
    }) => mixed,
    onChange?: ({
      currentTarget: { id: string, name: string, value: string }
    }) => mixed,
    placeholderClassName?: string,
    schema?: Object,
    showDescriptionInTooltip?: boolean,
    value?: any
  };*/
/*:: type State = { errorMessage?: string };*/
var Input = /*#__PURE__*/function (_React$PureComponent) {
  function Input() {
    var _this;
    (0, _classCallCheck2.default)(this, Input);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Input, [].concat(_args));
    (0, _defineProperty2.default)(_this, "state", {
      errorMessage: (0, _getErrorMessage.default)({
        name: _this.props.name,
        schema: _this.props.schema,
        value: _this.props.value
      }) || _this.props.errorMessage
    });
    (0, _defineProperty2.default)(_this, "_isMounted", false);
    (0, _defineProperty2.default)(_this, "setErrorMessage", function (value) {
      var _this$props = _this.props,
        errorMessageProp = _this$props.errorMessage,
        name = _this$props.name,
        schema = _this$props.schema,
        type = _this$props.type;
      var fieldValue = (0, _getFieldValue.default)(value, type);
      var errorMessage = (0, _getErrorMessage.default)({
        name: name,
        schema: schema,
        value: fieldValue
      }) || errorMessageProp;
      if (_this._isMounted) {
        _this.setState({
          errorMessage: errorMessage
        });
      }
    });
    (0, _defineProperty2.default)(_this, "debouncedSetErrorMessage", (0, _debounce.default)(function (value) {
      _this.setErrorMessage(value);
    }, _debounce2.WAIT));
    (0, _defineProperty2.default)(_this, "handleBlur", function (event) {
      var _ref = event || {},
        currentTarget = _ref.currentTarget;
      var _ref2 = currentTarget || {},
        value = _ref2.value;
      var onBlur = _this.props.onBlur;
      _this.setErrorMessage(value);
      if (typeof onBlur === 'function') {
        onBlur(event);
      }
    });
    (0, _defineProperty2.default)(_this, "handleChange", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var event = args[0];
      var _ref3 = event || {},
        currentTarget = _ref3.currentTarget;
      var _ref4 = currentTarget || {},
        value = _ref4.value;
      var onChange = _this.props.onChange;
      _this.debouncedSetErrorMessage(value);
      if (typeof onChange === 'function') {
        onChange.apply(void 0, args);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(Input, _React$PureComponent);
  return (0, _createClass2.default)(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.errorMessage !== prevProps.errorMessage) {
        this.setErrorMessage(this.props.value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        children = _this$props2.children,
        classes = _this$props2.classes,
        className = _this$props2.className,
        description = _this$props2.description,
        descriptionClassName = _this$props2.descriptionClassName,
        disabledProp = _this$props2.disabled,
        displayErrorsProp = _this$props2.displayErrors,
        errorProp = _this$props2.error,
        errorMessageProp = _this$props2.errorMessage,
        hasErrorProp = _this$props2.hasError,
        hasValidation = _this$props2.hasValidation,
        id = _this$props2.id,
        inputClassName = _this$props2.inputClassName,
        inputElementClassName = _this$props2.inputElementClassName,
        label = _this$props2.label,
        labelClassName = _this$props2.labelClassName,
        name = _this$props2.name,
        onBlur = _this$props2.onBlur,
        onChange = _this$props2.onChange,
        placeholder = _this$props2.placeholder,
        placeholderClassName = _this$props2.placeholderClassName,
        readOnlyProp = _this$props2.readOnly,
        required = _this$props2.required,
        _this$props2$showDesc = _this$props2.showDescriptionInTooltip,
        showDescriptionInTooltip = _this$props2$showDesc === void 0 ? false : _this$props2$showDesc,
        theme = _this$props2.theme,
        type = _this$props2.type,
        other = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var errorMessage = this.state.errorMessage;
      return children ? /*#__PURE__*/React.createElement(_WebformView.WebformViewConsumer, null, function () {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          disabled = _ref5.disabled,
          displayErrors = _ref5.displayErrors,
          readOnly = _ref5.readOnly,
          setDisplayErrorsState = _ref5.setDisplayErrorsState,
          setLoadingState = _ref5.setLoadingState;
        var error = errorProp instanceof Error ? errorProp.message : errorProp || ((displayErrorsProp || displayErrors) && hasValidation ? errorMessage : errorProp);
        return /*#__PURE__*/React.createElement("div", {
          className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.errorMargin, error), className),
          "data-id": name,
          "data-testid": "input",
          "data-error": hasValidation ? errorMessage : undefined
        }, showDescriptionInTooltip && /*#__PURE__*/React.createElement("div", {
          className: classes.tooltipContainer
        }, label && /*#__PURE__*/React.createElement("label", {
          className: (0, _classnames.default)(classes.label, classes.labelWithTooltip, labelClassName),
          "data-testid": "inline-input-label",
          htmlFor: !disabledProp && !disabled && !readOnlyProp && !readOnly ? id : undefined,
          id: "".concat(id, "-label")
        }, label), description && /*#__PURE__*/React.createElement(_Menu.default, {
          openerClassName: classes.openerContainer,
          opener: /*#__PURE__*/React.createElement(_info.ReactComponent, {
            className: classes.helpOpener
          })
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.tooltip
        }, /*#__PURE__*/React.createElement("label", {
          className: classes.tooltipLabel,
          "data-testid": "input-tooltip-label"
        }, label), /*#__PURE__*/React.createElement("div", {
          className: (0, _classnames.default)(classes.description, descriptionClassName),
          "data-testid": "input-tooltip-description",
          id: "".concat(id, "-description")
        }, description), /*#__PURE__*/React.createElement("div", {
          className: (0, _classnames.default)(classes.placeholder, placeholderClassName),
          "data-testid": "input-tooltip-placeholder"
        }, placeholder)))), !showDescriptionInTooltip && /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement("label", {
          className: (0, _classnames.default)(classes.label, labelClassName),
          "data-testid": "input-label",
          htmlFor: !disabledProp && !disabled && !readOnlyProp && !readOnly ? id : undefined,
          id: "".concat(id, "-label")
        }, label), description && /*#__PURE__*/React.createElement("div", {
          className: (0, _classnames.default)(classes.description, descriptionClassName),
          "data-testid": "input-description",
          id: "".concat(id, "-description")
        }, description), placeholder && /*#__PURE__*/React.createElement("div", {
          className: (0, _classnames.default)(classes.placeholder, placeholderClassName),
          "data-testid": "input-placeholder"
        }, placeholder)), children && React.Children.map(children, function (child) {
          return React.isValidElement(child) ? React.cloneElement(child, _objectSpread(_objectSpread(_objectSpread({}, other), {}, {
            'aria-describedby': description ? "".concat(id, "-description") : undefined
          }, error ? {
            'aria-invalid': true
          } : {}), {}, {
            'aria-labelledby': label ? "".concat(id, "-label") : undefined,
            className: (0, _classnames.default)(classes.input, inputClassName, child.props.className),
            disabled: disabledProp || disabled || child.props.disabled,
            displayErrors: displayErrorsProp || displayErrors || child.props.displayErrors,
            hasError: hasErrorProp || Boolean(error) || child.props.hasError,
            hasValidation: hasValidation || child.props.hasValidation,
            id: id || child.props.id,
            inputClassName: (0, _classnames.default)(inputElementClassName, child.props.inputClassName),
            name: name || child.props.name,
            onBlur: function onBlur(event) {
              _this2.handleBlur(event);
              if (child.props.onBlur) {
                child.props.onBlur(event);
              }
            },
            onChange: function onChange() {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var event = args[0];
              _this2.handleChange(event);
              if (child.props.onChange) {
                var _child$props;
                (_child$props = child.props).onChange.apply(_child$props, args);
              }
            },
            readOnly: readOnlyProp || readOnly || child.props.readOnly,
            required: required || child.props.required,
            setDisplayErrorsState: setDisplayErrorsState,
            setLoadingState: setLoadingState
          })) : child;
        }), error && /*#__PURE__*/React.createElement("div", {
          className: classes.errorMessage,
          "data-testid": "error-message"
        }, error));
      }) : null;
    }
  }]);
}(React.PureComponent);
(0, _defineProperty2.default)(Input, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(Input, "defaultProps", {
  disabled: false,
  displayErrors: false,
  hasError: false,
  hasValidation: false,
  readOnly: false,
  required: false
});
var _default = exports.default = (0, _recompose.compose)((0, _injectSheet.default)(Style), (0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _recompose.withProps)(function (_ref6) {
  var _ref6$id = _ref6.id,
    id = _ref6$id === void 0 ? (0, _nextInputID.default)() : _ref6$id;
  return {
    id: id
  };
}))(Input);
//# sourceMappingURL=Input.js.map